/**
 * Extracts display initials from a displayName.
 *
 * Priority:
 *   1. displayName  – split on whitespace or dots → up to 2 initials
 *   2. Fallback     – '?'
 */
export function getInitials(displayName: string | null | undefined): string {
  const fromName = extractInitials(displayName);
  if (fromName) return fromName;

  return '?';
}

function extractInitials(value: string | null | undefined): string {
  if (!value) return '';
  const trimmed = value.trim();
  if (!trimmed) return '';

  // Split on whitespace, dots, hyphens or underscores
  const parts = trimmed.split(/[\s.\-_]+/).filter((p) => p.length > 0);

  if (parts.length >= 2) {
    // Take first letter of first and last meaningful segment
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }

  // Single token → only first letter
  return parts[0][0].toUpperCase();
}
